export default __webpack_public_path__ + "static/media/traffic-signal-error2.ba610bce.svg";